import dayjs from "dayjs"
import { SimpleBarChartDataItem } from "../../../models/charts"
import { getDateRangeValues, decimalToTime } from "../../BasicCalendar/Utils"


export const fillRangeValues = (from_date: string, to_date: string, input_data: SimpleBarChartDataItem[]): SimpleBarChartDataItem[] => {
  const res: SimpleBarChartDataItem[] = []

  for (const date_range of getDateRangeValues(dayjs(from_date), dayjs(to_date))) {
    let input_item: SimpleBarChartDataItem = input_data.find(obj => obj.x === date_range.format('YYYY-MM-DD')) ?? { x: date_range.format('MM-DD'), y: 0 }

    res.push({ x: dayjs(input_item.x).format('MM-DD'), y: input_item.y })
  }

  return res

}


export const getYTicks = (input_values: number[], splits: number = 4): number[] => {
  const res: number[] = [0]

  const max_value: number = Math.ceil(Math.max(...input_values))
  let step: number = Math.ceil(max_value / splits)
  step = step > 0 ? step : 1
  let current: number = step

  while (current < max_value) {
    res.push(current)
    current += step
  }

  res.push(current)

  if ((current - max_value) < (step / 4)) {
    res.push(current + step)
  }

  return res

}

export const setBarLabel = ({ x, y, value, barSize = 30 }: any) => {
  const fontSize = 11
  return <>
    {(value > 0) && (
      <g>
        <rect
          x={x + barSize / 3.5 - fontSize}
          y={y - fontSize - 6}
          width={2 + fontSize * 3}
          height={fontSize + 4}
          fill="#FFFF8F"
          rx={4}
        />

        <text
          x={x + barSize / 2}
          y={y - 5}
          textAnchor='middle'
          fontSize={fontSize}
        >
          {value}
        </text>
      </g>
    )}
  </>
}

export const setBarLabelAsTime = ({ x, y, value, barSize = 30 }: any) => {
  const fontSize = 11
  return <>
    {(value > 0) && (
      <g>
        <rect
          x={x + barSize / 3.5 - fontSize}
          y={y - fontSize - 6}
          width={2 + fontSize * 3}
          height={fontSize + 4}
          fill="#FFFF8F"
          rx={4}
        />

        <text
          x={x + barSize / 2}
          y={y - 5}
          textAnchor='middle'
          fontSize={fontSize}
        >
          {decimalToTime(value)}
        </text>
      </g>
    )}
  </>
}